import React from "react";
import Navbar from "../../components/navbar/Navbar";
import NewOrder from "../../components/orders/NewOrder";
import { useLocation } from "react-router-dom";

const NewOrderPage = () => {
  const { state } = useLocation();
  return (
    <>
      <section className="bajaj_main_block">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 p-0">
              {state?.id ? (
                <Navbar content="EDIT ORDER" />
              ) : (
                <Navbar content="NEW ORDER" />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 p-0">
              <NewOrder />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewOrderPage;
